module.exports = __webpack_public_path__ + "static/media/Safari_PSD_Mockup.be03d24b.png";